import { useSnackbar } from "notistack";

import CheckIcon from "../../../../../components/CheckIcon";

import { useTranslation } from "react-i18next";
import { useAddRecipientsFromCSVMutation } from "../../../recipientsApiSlice";

const SaveButton = ({ rowData, rowIndex, handleRemove }) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [addRecipients, { isLoading }] = useAddRecipientsFromCSVMutation();

	const handleRowSave = async () => {
		const name = rowData[2];
		const firstName = rowData[3];
		const lastName = rowData[4];
		const nip = rowData[5];
		const email = rowData[6];
		const phone = rowData[7];
		const groupsIds = Object.entries(rowData[8])
			.filter(([_id, item]) => item.checked === true)
			.map(([id, _item]) => id);

		if (
			groupsIds.length < 1 ||
			!name ||
			name.length < 1 ||
			!email ||
			email.length < 1
		) {
			enqueueSnackbar(t("fill_required_fields"), {
				variant: "error",
			});
			return;
		}

		const parsedData = {
			groupsIds,
			data: [{ name, firstName, lastName, nip, email, phone }],
		};

		await addRecipients({ data: parsedData })
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("import_added_carrier_to_group"), {
					variant: "success",
				});
				handleRemove(rowIndex);
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([_key, message]) => {
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	return <CheckIcon onClick={handleRowSave} />;
};

export default SaveButton;
